/**
 * @param {Array<{ key: string, label: string, filterOptions?: string[], getDisplayValue?: (row: any) => any, translateDisplayValue?: boolean }>} columns
 * @param {(key: string, vars?: Record<string, unknown>) => string} t
 * @returns {Array<{ key: string, label: string, filterOptions?: Array<string|{ value: string, label: string }> }>}
 */
export function translateColumns(columns, t) {
	return columns.map(col => ({
		...col,
		label: t('column.' + col.key),
		filterOptions: col.filterOptions ? col.filterOptions.map(opt => ({ value: opt, label: t('option.' + opt) })) : col.filterOptions,
		...(col.translateDisplayValue && col.getDisplayValue
			? { getDisplayValue: (row) => {
				const value = col.getDisplayValue(row);
				return value === null || value === undefined ? value : t('option.' + value);
			} }
			: {}),
		...(col.filterOptions && !col.getDisplayValue
			? { getDisplayValue: (row) => t('option.' + col.getValue(row)) }
			: {}),
	}));
}
